// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"532":"f6612216d42fd5bb","888":"f52b5a0fc2285ec7"}[chunkId] + ".css";
};